import { Typography } from "@kyan/ui";
import { TableColumn } from "@kyan/ui";

import { Krystal } from "#/components/Krystal/Krystal";

import { SummaryRow } from "./Summary.controller";

export const getColumns = (): TableColumn<SummaryRow>[] => [
  ...Array.from({ length: 5 }, (_, index) => ({
    id: `empty-${index}`,
    maxWidth: [0, 1].includes(index) ? "100px" : undefined,
  })),
  {
    id: "total",
    maxWidth: "100px",
    cell: (row) => (
      <div className="flex flex-col gap-1">
        <Typography size={10} className="text-textSecondary">
          Total
        </Typography>
        <div className="flex items-center">
          <Krystal size={20} className="-ml-1" />
          <Typography className="dark:text-textPrimary text-black">
            {row.total || "Coming soon"}
          </Typography>
        </div>
      </div>
    ),
  },
];
